export default __webpack_public_path__ + "static/media/ah.6d938121.png";